import React from 'react';
import { View, Image, Text } from 'react-native';

import styles from "./styles";

const HeaderInfoCoin = ({ dataCoin }) => {
    return (
        <>
            {
                dataCoin && (
                    <View style={styles.contentHeaderCoin2}>

                        <View style={styles.contentDescriptionCoin}>
                        {
                                dataCoin.actives !== undefined && !dataCoin.actives[0].cryptoactive ? 
                                    <>
                                        <Text style={styles.titleCirculation}>Em circulação:</Text>
                                        <Text style={styles.amountCirculation}>{dataCoin?.count} {dataCoin?.count && dataCoin.actives[0].name_token}</Text>
                                    </> 
                                    : 
                                    <></>
                            }
                        </View>
                        <View style={styles.imageContainer}>
                            <Image style={styles.imgCoin} source={{ uri: dataCoin.actives !== undefined ? `https://filesgpx.s3.us-east-2.amazonaws.com/${dataCoin.actives[0].path}` : null }} />
                        </View>
                        <View style={styles.priceContainer}>
                            <Text style={styles.nameCoin}>{dataCoin.actives !== undefined ? dataCoin.actives[0].name_token : ''}</Text>
                            <Text style={styles.priceCoin}>GPX {dataCoin.actives !== undefined ? dataCoin.actives[0].type_value == "Valor Fixo" ? dataCoin.actives[0].single_value : dataCoin.actives[0].total_value_token : "000"}</Text>
                        </View>
                        {/* <View style={styles.contentHeaderCoin}>
                        </View> */}
                    </View>
                )
            }
        </>
    );
}

export default HeaderInfoCoin;